/* MOREOVER interactive garment measurement units; delegated events also work in Shopify theme editor section reloads. */
(function () {
  if (window.mrvrSizeTableReady) return;
  window.mrvrSizeTableReady = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mrvr-unit]');
    if (!button) return;
    var guide = button.closest('[data-mrvr-measurements]');
    if (!guide) return;
    var unit = button.getAttribute('data-mrvr-unit');
    if (unit !== 'cm' && unit !== 'in') return;
    guide.querySelectorAll('[data-mrvr-unit]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });
    guide.querySelectorAll('[data-mrvr-cm]').forEach(function (cell) {
      var cm = cell.getAttribute('data-mrvr-cm');
      var number = Number(cm);
      cell.textContent = unit === 'in' && Number.isFinite(number) ? (number / 2.54).toFixed(1) : cm;
    });
    var label = guide.querySelector('[data-mrvr-unit-label]');
    if (label) label.textContent = unit === 'in' ? 'inches' : 'centimeters';
  });
})();